import { render, staticRenderFns } from "./ContaPagarManter.vue?vue&type=template&id=1d89c0a2&"
import script from "./ContaPagarManter.vue?vue&type=script&lang=js&"
export * from "./ContaPagarManter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports